<template>
  <div class="px-4 py-5 bg-light mb-5 text-center">
    <h3 class="h5">
      <i class="far fa-envelope me-2"></i>Enter your email here
    </h3>
    <p class="text-sm">Subscribe to my weekly newsletter</p>
    <form @submit.prevent="subscribe">
      <div class="mb-1">
        <input
          class="form-control form-control-sm"
          type="email"
          name="email"
          placeholder="Emaill address"
          v-model="email"
          required
        />
      </div>
      <div class="mb-0">
        <button class="btn btn-dark w-100 btn-sm" type="submit">
          Subscribe
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: "SubscribeSidebar",
  data() {
    return {
      email: "",
    };
  },
  methods: {
    async subscribe() {
      try {
        const response = await fetch("/api/subscribe", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: this.email }),
        });

        const data = await response.json();

        // Handle success or error messages
        alert(data.message || data.error);
      } catch (error) {
        console.error("Error subscribing:", error);
        alert("An error occurred while subscribing. Please try again.");
      }
    },
  },
};
</script>
